import { useMemo } from 'react';

import { ADJUSTMENT_REASON_OPTIONS } from '@atom/components/common/requests/assetRequestConstants';
import { Progress, Select, TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AssetBudget, AssetDetail } from '@atom/types/asset';
import { AssetRequestCreateInput } from '@atom/types/assetRequest';

import QuantityAdjustmentSubtext from './QuantityAdjustmentSubtext';

import classes from './sddotCreate.module.css';

const { MenuItem } = Select;

const styles = {
  label: {
    color: colors.neutral.dim,
  },
};

type SDDOTAdjustmentCreateProps = {
  budget: AssetBudget;
  createInputs: AssetRequestCreateInput;
  updateCreateInput: (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => void;
  asset: AssetDetail;
  // TODO: [AM-16707]: Temp code until BE solution is built
  totalRemaining: number;
  totalRemainingLoading: boolean;
};

const SDDOTAdjustmentCreate = ({
  budget,
  asset,
  createInputs,
  updateCreateInput,
  // TODO: [AM-16707]: Temp code until BE solution is built
  totalRemaining,
  totalRemainingLoading,
}: SDDOTAdjustmentCreateProps) => {
  // const quantityError = useMemo(() => {
  //   const updatedQuantity =
  //     Number(budget?.quantityOnHand) + Number(createInputs?.quantity);

  //   return updatedQuantity < 0;
  // }, [createInputs.quantity]);

  const quantityError = useMemo(() => {
    const updatedQuantity =
      Number(totalRemaining) + Number(createInputs?.quantity);

    return updatedQuantity < 0;
  }, [createInputs.quantity, totalRemaining, totalRemainingLoading]);

  const numberUpdate = (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => {
    const updatedValue = Math.abs(Number(value)) === 0 ? null : Number(value);
    updateCreateInput(updatedValue, property);
  };

  return (
    <>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Inventory Name</div>
        <div>{asset?.name}</div>
      </div>
      <div className={classes.inputContainer}>
        <TextField
          slotProps={{ inputLabel: { style: styles.label } }}
          type="number"
          value={createInputs?.quantity || ''}
          label={`Quantity Adjusted (${budget?.unit})`}
          onChange={event => numberUpdate(event.target.value, 'quantity')}
          // helperText={`${budget?.quantityOnHand} ${budget?.unit} in stock`}
          helperText={
            totalRemainingLoading ? (
              <Progress size={10} />
            ) : (
              `${totalRemaining} ${budget?.unit} in stock`
            )
          }
          error={quantityError}
          data-cy="assetRequestAdjustmentQuantity"
        />
        <QuantityAdjustmentSubtext
          quantity={createInputs?.quantity}
          budget={budget}
          dataCy="assetRequestAdjustmentQuantitySubtext"
          totalRemaining={totalRemaining}
          totalRemainingLoading={totalRemainingLoading}
        />
      </div>
      <div className={classes.inputContainer}>
        <Select
          key="adjustmentReason"
          label="Adjustment Reason"
          InputLabelProps={{ style: { color: colors.neutral.dim } }}
          fullWidth
          onChange={event => updateCreateInput(event.target.value, 'reason')}
          value={createInputs.reason}
          data-cy="assetRequestAdjustmentReasonSelect"
        >
          {ADJUSTMENT_REASON_OPTIONS.map((option: string, index: number) => (
            <MenuItem key={index} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className={classes.inputContainer}>
        <TextField
          multiline
          slotProps={{ inputLabel: { style: styles.label } }}
          value={createInputs?.comments}
          label="Comments"
          onChange={event => updateCreateInput(event.target.value, 'comments')}
          data-cy="assetRequestAdjustmentComment"
        />
      </div>
    </>
  );
};

export default SDDOTAdjustmentCreate;
